import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LhWorkbenchModule } from '@ewafi/angular/panels/workbench';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    LhWorkbenchModule,
  ],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss',
})
export class AppComponent {}
